// src/components/PublicFooter.jsx

import {
  Box,
  Container,
  Divider,
  Flex,
  IconButton,
  Link,
  SimpleGrid,
  Text,
  VStack,
} from "@chakra-ui/react";

import { Link as RouterLink } from "react-router-dom";

import {
  FaFacebookF,
  FaInstagram,
  FaTiktok,
  FaXTwitter,
} from "react-icons/fa6";

import BrandLogo from "./BrandLogo";

const BRAND_RED = "#E63946";
const BRAND_RED_DARK = "#C92A37";
const BRAND_RED_LIGHT = "#FFF5F5";

const socialLinks = [
  {
    label: "Facebook",
    href: "https://facebook.com/postcodecoupons",
    icon: FaFacebookF,
  },
  {
    label: "Instagram",
    href: "https://instagram.com/postcodecoupons",
    icon: FaInstagram,
  },
  {
    label: "TikTok",
    href: "https://tiktok.com/@postcodecoupons",
    icon: FaTiktok,
  },
  {
    label: "X",
    href: "https://twitter.com/postcodecoupon",
    icon: FaXTwitter,
  },
];

export default function PublicFooter() {
  return (
    <Box
      as="footer"
      bg={BRAND_RED}
      color="white"
      mt={20}
    >
      <Container
        maxW="container.xl"
        py={{
          base: 8,
          md: 10,
        }}
      >
        <SimpleGrid
          columns={{
            base: 1,
            md: 2,
          }}
          spacing={{
            base: 8,
            md: 12,
          }}
          alignItems="start"
        >
          {/* BRAND */}

          <VStack
            align="flex-start"
            spacing={3}
          >
            <RouterLink to="/">
              <BrandLogo size={34} />
            </RouterLink>

            <Text
              fontSize="lg"
              fontWeight="extrabold"
              letterSpacing="-0.02em"
            >
              postcode.coupons
            </Text>

            <Text
              maxW="420px"
              fontSize="sm"
              lineHeight="1.7"
              color="whiteAlpha.900"
            >
              Coupons by postcode sector, delivered directly
              to households.
            </Text>

            {/* SOCIALS */}

            <Flex
              gap={2}
              pt={2}
            >
              {socialLinks.map((social) => {
                const Icon = social.icon;

                return (
                  <IconButton
                    key={social.label}
                    as="a"
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.label}
                    icon={<Icon />}
                    size="sm"
                    borderRadius="full"
                    bg="whiteAlpha.200"
                    color="white"
                    borderWidth="1px"
                    borderColor="whiteAlpha.300"
                    _hover={{
                      bg: "white",
                      color: BRAND_RED_DARK,
                      transform: "translateY(-2px)",
                    }}
                  />
                );
              })}
            </Flex>
          </VStack>

          {/* LINKS */}

          <Flex
            justify={{
              base: "flex-start",
              md: "flex-end",
            }}
            gap={{
              base: 10,
              md: 14,
            }}
            flexWrap="wrap"
          >
            <VStack
              align="flex-start"
              spacing={3}
            >
              <Text
                fontSize="xs"
                fontWeight="extrabold"
                textTransform="uppercase"
                letterSpacing="wide"
                color="whiteAlpha.800"
              >
                Explore
              </Text>

              <FooterLink to="/">
                🎟️ Find coupons
              </FooterLink>

              <FooterLink to="/map">
                🗺️ Map
              </FooterLink>

              <FooterLink to="/coupon-ads">
                🏢 For businesses
              </FooterLink>

              <FooterLink to="/pricing">
                💷 Pricing
              </FooterLink>
            </VStack>

            <VStack
              align="flex-start"
              spacing={3}
            >
              <Text
                fontSize="xs"
                fontWeight="extrabold"
                textTransform="uppercase"
                letterSpacing="wide"
                color="whiteAlpha.800"
              >
                Legal
              </Text>

              <FooterLink to="/privacy">
                Privacy Policy
              </FooterLink>

              <FooterLink to="/cookies">
                Cookie Policy
              </FooterLink>

              <FooterLink to="/terms">
                Terms of Service
              </FooterLink>
            </VStack>
          </Flex>
        </SimpleGrid>

        <Divider
          my={{
            base: 7,
            md: 8,
          }}
          borderColor="whiteAlpha.300"
        />

        {/* BOTTOM BAR */}

        <Flex
          direction={{
            base: "column",
            sm: "row",
          }}
          justify="space-between"
          align={{
            base: "flex-start",
            sm: "center",
          }}
          gap={3}
        >
          <Text
            fontSize="xs"
            color="whiteAlpha.800"
          >
            © {new Date().getFullYear()} POSTCODE.COUPONS LIMITED
          </Text>

          <Text
            fontSize="xs"
            color="whiteAlpha.800"
          >
            Company No. 16680754
          </Text>
        </Flex>
      </Container>

      {/* SMALL BRAND STRIP */}

      <Box
        height="4px"
        bg={BRAND_RED_DARK}
      />
    </Box>
  );
}

function FooterLink({
  to,
  children,
}) {
  return (
    <Link
      as={RouterLink}
      to={to}
      color="white"
      fontSize="sm"
      fontWeight="semibold"
      textDecoration="none"
      _hover={{
        color: BRAND_RED_LIGHT,
        textDecoration: "underline",
        textUnderlineOffset: "4px",
      }}
    >
      {children}
    </Link>
  );
}